export default __webpack_public_path__ + "static/media/mobile-2.fad872a0.png";